// extracted by mini-css-extract-plugin
module.exports = {"main":"main--3sNRF"};
    if(module.hot) {
      // 1637785516344
      var cssReload = require("/Users/nicholasrq/Git/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  